import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLang } from './context/LanguageContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Listing from './pages/Listing';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import Management from './pages/Management';
import WhoWeAre from './pages/WhoWeAre';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminGuard from './pages/admin/AdminGuard';

function ListingRoute({ status, labelKey }) {
  const { t } = useLang();
  return <Listing title={t.nav[labelKey]} filter={status} />;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="new-projects" element={<ListingRoute status="new-projects" labelKey="new_projects" />} />
              <Route path="for-sale" element={<ListingRoute status="for-sale" labelKey="for_sale" />} />
              <Route path="for-rent" element={<ListingRoute status="for-rent" labelKey="for_rent" />} />
              <Route path="who-we-are" element={<WhoWeAre />} />
              <Route path="management" element={<Management />} />
              <Route path="contact" element={<Contact />} />
              <Route path="project/:slug" element={<ProjectDetail />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminDashboard />
                </AdminGuard>
              }
            />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
